module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABCElEQVR42mNgGAWjYBSMglEwtIDCYHPQg0HlqOLi4v9EOkoSiDOAeDkQXwHpg2FFRcU3QLGDQNwFxE5AzESRgwg4yhyINyA7gBAWExN7CdRTDsTcZDsIi6NEgHgpKQ5Bx3p6eu+BZgST7SAkR4WCogGfZUA1l4D4MBAfZ2JiekhA7XQgZiXLQQQM7gZiUyBmxmIUKERjgHgvDr1bgJidKg4CKusAYl4SAt4aFIJYzFkFxIwUOQjqa3IAGxDPwWJeGaUOorScmoDFTA1Ko4wSR4GiaAuaeZspTtQUOkoci3l61MhllDiqGs2sNoodRKGjhID4JhD3ArElwdw2CkbBKBgFo2AUDCEAAJtyl1octM58AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf-viewer/ic_undo.png
// module id = 1279
// module chunks = 438